import { render, staticRenderFns } from "./SelectAreaView.vue?vue&type=template&id=1c2436d2"
import script from "./SelectAreaView.vue?vue&type=script&lang=js"
export * from "./SelectAreaView.vue?vue&type=script&lang=js"
import style0 from "./SelectAreaView.vue?vue&type=style&index=0&id=1c2436d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports